import {
    Avatar,
    Button,
    Divider,
    Flexer,
    FormHelperText,
    Heading,
    Icon,
    IconLib,
    Input,
    InputControl,
    InputPrefix,
    Label,
    Modal,
    ModalClose,
    Pill,
    Portal,
    Select,
    SelectOption,
    Stack,
    Text,
    Toggle,
    View,
    getKey,
    timezones,
    useInput,
    useToggle,
} from '@fold-dev/core'
import { useContext, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router'
import { ColorButton, CommonContext, Error, ListButton, UserMenu, UserSelect, UserSelectUser } from '../components'
import { Loading } from '../components'
import { useProjects, useWorkspaceUsers } from '../hooks/api.hooks'
import { useAuth } from '../hooks/auth.hook'
//import { availableUsers, listOptions, selectedUsers } from './new-task.modal'
import { AiOutlineDelete } from 'react-icons/ai'
import { TbUserPlus } from 'react-icons/tb'

export const TeamSelect = () => {
    const [selected, setSelected] = useState<any>([])

    const handleSelect = (option, dismiss) => {
        if (selected.includes(option.key)) {
            setSelected([...selected.filter((optionKey) => option.key != optionKey)])
        } else {
            setSelected([...selected, option.key])
        }
    }

    return (
        <Select
            prefix={<Icon icon={TbUserPlus} />}
            width="100%"
            placeholder="Select a team"
            selected={selected}
            onSelect={handleSelect}
            options={timezones.map((tz) => ({
                key: tz,
                label: tz,
            }))}
        />
    )
}

export default function NewProjectModal({ noPrivateOption = false, onDismiss, onCreate }) {
    return <div />
}
/* 
export default function NewProjectModal({ noPrivateOption = false, onDismiss, onCreate }) {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const isClosed = useToggle(false)
    const isPrivate = useToggle()
    const { getUserId } = useAuth()
    const name = useInput('')
    const { workspaceId } = useParams()
    const { getSearch } = useWorkspaceUsers()
    const { create } = useProjects()
    const [available, setAvailable] = useState<any>([])
    const [users, setUsers] = useState<any>(selectedUsers)
    const [color, setColor] = useState('')
    const { colors } = useContext(CommonContext)

    const handleCreateProject = async () => {
        setLoading(true)
        setError(null)

        try {
            const { id } = await create(workspaceId, {
                name: name.value,
                description: '',
                icon: '',
                color: '',
                isPrivate: isPrivate.on,
                isClosed: isClosed.on,
                users: [...users, { id: getUserId() }],
            })

            onCreate(id)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            setError(typeof e == 'string' ? e : 'An error occured')
        }
    }

    const handleUserAdd = (user) => setUsers([...users, user])

    const handleUserDelete = (user) => setUsers(users.filter((u) => u.id != user.id))

    const handleFilter = async (query) => {
        if (users.length >= 8) return setError('Sorry, the limit has been reached.')

        setLoading(true)
        setError(null)

        try {
            const users = await getSearch(workspaceId, query)

            setAvailable(users)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            setError(typeof e == 'string' ? e : 'An error occured')
        }
    }
    const selected = useMemo(() => users.map((user: UserSelectUser) => user.id), [users])
    const options: any = useMemo(() => {
        return availableUsers.map((user: UserSelectUser) => ({
            key: user.id,
            label: user.name,
            prefix: (
                <Avatar
                    src={user.image}
                    name={user.name}
                    size="xs"
                />
            ),
        }))
    }, [availableUsers])

    const handleUserFilter = (text) => {}

    const handleUserSelect = (option: SelectOption) => {
        const user = availableUsers.find((availableUser: any) => availableUser.id == option.key)

        if (!!users.find((user: any) => user.id == option.key)) {
            //onDelete(user)
        } else {
            //onAdd(user)
        }
    }

    const handleInputKeyDown = (e) => {
        const { isBackspace } = getKey(e)
        if (isBackspace && !e.target.value) AiOutlineDelete(users[users.length - 1])
    }

    useEffect(() => {
        if (isPrivate.on) isClosed.turnOff()
    }, [isPrivate.on])

    return (
        <Modal
            isVisible={true}
            width={500}
            height="fit-content"
            onDismiss={onDismiss}
            portal={Portal}
            style={{
                marginTop: -100,
            }}
            header={
                <>
                    <Heading as="h4">New Project</Heading>
                    <Flexer />
                    <ModalClose onClick={onDismiss} />
                </>
            }
            footer={
                <>
                    <View
                        row
                        gap="1rem">
                        <Button onClick={onDismiss}>Cancel</Button>
                        <Label
                            htmlFor="closed"
                            disabled={isPrivate.on}>
                            Private Project
                        </Label>
                        <Toggle
                            id="closed"
                            onChange={isClosed.toggle}
                            on={isClosed.on}
                            disabled={isPrivate.on}
                        />
                    </View>
                    <Flexer />
                    <Button
                        variant="accent"
                        onClick={handleCreateProject}>
                        Create Project
                    </Button>
                </>
            }>
            <View>
                <Error error={error} />
                <Loading loading={loading} />

                <Stack
                    direction="vertical"
                    spacing="0.75rem">
                    <Label
                        fontWeight={600}
                        colorToken="accent"
                        size="sm">
                        New project name
                    </Label>

                    <InputControl>
                        <InputPrefix>
                            <ColorButton
                                color={color}
                                onChange={setColor}
                                colors={colors}
                            />
                        </InputPrefix>
                        <Input
                            placeholder="Website Launch"
                            value={name.value}
                            onChange={name.onChange}
                            // size="lg"
                        />
                    </InputControl>

                    <Label
                        fontWeight={600}
                        colorToken="accent"
                        size="sm">
                        New project team
                    </Label>

                    <TeamSelect />
                    <View
                        row
                        justifyContent="flex-start">
                        <ListButton
                            icon={FolderIcon}
                            options={listOptions}
                            list={0}
                            onChange={(list) => null}
                        />
                    </View>

                    {isClosed.on && (
                        <>
                            <Divider />

                            <Label
                                fontWeight={600}
                                colorToken="accent"
                                size="sm">
                                Private Project Members
                            </Label>

                            <Select
                                width="100%"
                                prefix={<Icon icon={UserPlusIcon} />}
                                tagInput
                                noListFocus
                                trapFocus
                                placeholder="Add user"
                                selected={selected}
                                options={options}
                                filterDelay={1000}
                                selectListProps={{
                                    noOptionsComponent: (
                                        <Text p="var(--f-select-option-padding)">No users available</Text>
                                    ),
                                }}
                                tagInputFieldProps={{ onKeyDown: handleInputKeyDown }}
                                onSelect={(option, dismiss, clear) => {
                                    clear()
                                    handleUserSelect(option)
                                }}
                                onFilter={handleUserFilter}
                                render={() =>
                                    users.map((user: UserSelectUser, index: number) => (
                                        <Pill
                                            subtle
                                            key={index}
                                            size="sm"
                                            prefix={
                                                <Avatar
                                                    src={user.image}
                                                    name={user.name}
                                                    size="xs"
                                                />
                                            }
                                            suffix={
                                                <IconLib
                                                    icon="x"
                                                    className="f-buttonize"
                                                    onClick={() => {
                                                        //onDelete(user)
                                                    }}
                                                />
                                            }>
                                            {user.name}
                                        </Pill>
                                    ))
                                }
                            />

                            <FormHelperText>You are able to add up to 8 users</FormHelperText>
                        </>
                    )}
                </Stack>
            </View>
        </Modal>
    )
}
 */
